import u from "./_arrayMap.js";
import y from "./_baseGet.js";
import b from "./_baseIteratee.js";
import c from "./_baseMap.js";
import l from "./_baseSortBy.js";
import s from "./_baseUnary.js";
import _ from "./_compareMultiple.js";
import d from "./identity.js";
import M from "./isArray.js";
var a = u, v = y, B = b, x = c, g = l, h = s, A = _, G = d, I = M;
function O(t, o, i) {
  o.length ? o = a(o, function(r) {
    return I(r) ? function(n) {
      return v(n, r.length === 1 ? r[0] : r);
    } : r;
  }) : o = [G];
  var m = -1;
  o = a(o, h(B));
  var e = x(t, function(r, n, S) {
    var f = a(o, function(p) {
      return p(r);
    });
    return { criteria: f, index: ++m, value: r };
  });
  return g(e, function(r, n) {
    return A(r, n, i);
  });
}
var F = O;
export {
  F as default
};
//# sourceMappingURL=_baseOrderBy.js.map
